var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VehicleDetail',{attrs:{"Project":"QM"}})
}
var staticRenderFns = []

export { render, staticRenderFns }